import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
    wrapper: {
        paddingBottom: '20px',
        position: 'relative'
    },
    hint: { fontSize: 13, color: theme.palette.text.secondary, alignSelf: 'center', marginRight: 12 },
    inputWrap:{
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        flexWrap: 'nowrap',
        '&>div': {
            flexShrink: 1,
        },

    },
    columnInputs: {
        display: "flex",
        justifyContent: 'center',
        // maxWidth: '100%',
        // '&>div': {
        //     flexShrink: 1,
        // },
    },
    rightColumn: {
        display: "flex",
        flexDirection: "column",
        maxWidth: 'calc(100% - 320px)'
    },
    buttonWrap: {
        display: "flex",
        justifyContent: 'end',
        maxWidth: '940px',
        margin: '0 auto',
        padding: "20px 8px 0",
        gap: 8,
    },
    giftCardLoader: {
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 100,
    },
}));
